import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'permission'

const PermissionModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default PermissionModule
